/* THIS IS A GENERATED FILE, DO NOT EDIT */
import * as GraphqlTypes from "./supergraphTypes";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetArenasDocument = gql`
    query GetArenas($searchTerm: String) {
  arenas(searchTerm: $searchTerm) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetArenasQuery__
 *
 * To run a query within a React component, call `useGetArenasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenasQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetArenasQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>(GetArenasDocument, options);
      }
export function useGetArenasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>(GetArenasDocument, options);
        }
// @ts-ignore
export function useGetArenasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>;
export function useGetArenasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenasQuery | undefined, GraphqlTypes.GetArenasQueryVariables>;
export function useGetArenasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>(GetArenasDocument, options);
        }
export type GetArenasQueryHookResult = ReturnType<typeof useGetArenasQuery>;
export type GetArenasLazyQueryHookResult = ReturnType<typeof useGetArenasLazyQuery>;
export type GetArenasSuspenseQueryHookResult = ReturnType<typeof useGetArenasSuspenseQuery>;
export type GetArenasQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>;
export const GetDataVaultEntitiesDocument = gql`
    query GetDataVaultEntities($arenaIds: [ID!]!, $searchTerm: String) {
  dataVaultEntities(
    input: {arenaIds: $arenaIds, searchTerm: $searchTerm}
    first: 100
  ) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetDataVaultEntitiesQuery__
 *
 * To run a query within a React component, call `useGetDataVaultEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataVaultEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataVaultEntitiesQuery({
 *   variables: {
 *      arenaIds: // value for 'arenaIds'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetDataVaultEntitiesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDataVaultEntitiesQuery, GraphqlTypes.GetDataVaultEntitiesQueryVariables> & ({ variables: GraphqlTypes.GetDataVaultEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDataVaultEntitiesQuery, GraphqlTypes.GetDataVaultEntitiesQueryVariables>(GetDataVaultEntitiesDocument, options);
      }
export function useGetDataVaultEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDataVaultEntitiesQuery, GraphqlTypes.GetDataVaultEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDataVaultEntitiesQuery, GraphqlTypes.GetDataVaultEntitiesQueryVariables>(GetDataVaultEntitiesDocument, options);
        }
// @ts-ignore
export function useGetDataVaultEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataVaultEntitiesQuery, GraphqlTypes.GetDataVaultEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataVaultEntitiesQuery, GraphqlTypes.GetDataVaultEntitiesQueryVariables>;
export function useGetDataVaultEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataVaultEntitiesQuery, GraphqlTypes.GetDataVaultEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDataVaultEntitiesQuery | undefined, GraphqlTypes.GetDataVaultEntitiesQueryVariables>;
export function useGetDataVaultEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDataVaultEntitiesQuery, GraphqlTypes.GetDataVaultEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDataVaultEntitiesQuery, GraphqlTypes.GetDataVaultEntitiesQueryVariables>(GetDataVaultEntitiesDocument, options);
        }
export type GetDataVaultEntitiesQueryHookResult = ReturnType<typeof useGetDataVaultEntitiesQuery>;
export type GetDataVaultEntitiesLazyQueryHookResult = ReturnType<typeof useGetDataVaultEntitiesLazyQuery>;
export type GetDataVaultEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetDataVaultEntitiesSuspenseQuery>;
export type GetDataVaultEntitiesQueryResult = Apollo.QueryResult<GraphqlTypes.GetDataVaultEntitiesQuery, GraphqlTypes.GetDataVaultEntitiesQueryVariables>;